// src/components/SocialIcons.jsx
import React from 'react';
import '../styles/social-icons.css';

const SocialIcons = ({ socialIcons = [] }) => {
  if (!socialIcons.length) return null;

  // 우선순위: s.icon → s.img → /assets/icons/<label>.svg → emoji/text
  const getIconSrc = (s) => s.icon || s.img || `/assets/icons/${(s.label || '').toLowerCase()}.svg`;

  return (
    <div className="social-icons" aria-label="소셜 바로가기">
      {socialIcons.map((s, i) => {
        const src = getIconSrc(s);
        const hasImage = !!src && !/^[\u2600-\u27BF\u1F300-\u1F9FF]/.test(src); // 간단 폴백 판별

        return (
          <a
            key={i}
            href={s.href || '#'}
            className={`social-icon ${s.className || ''}`}
            aria-label={s.label || 'social link'}
          >
            {hasImage ? (
              <img
                src={src}
                alt={s.label || 'social'}
                className="social-icon-img"
                loading="lazy"
              />
            ) : (
              s.emoji || s.text || s.label
            )}
          </a>
        );
      })}
    </div>
  );
};

export default SocialIcons;
